import {
  GetWorkSpacesWithBookingsDocument,
  GetWorkSpacesWithBookingsQuery,
  GetWorkSpacesWithBookingsQueryVariables,
} from 'generated/resources/graphql'

import { usePaginatedQuery } from 'modules/core/hooks/usePaginatedQuery'

import { DEFAULT_PAGINATED_CONNECTION } from 'modules/space_control/hooks/utils'

export type WorkSpaceWithBookingNode =
  GetWorkSpacesWithBookingsQuery['spaceControl']['workSpaceWithBookingsConnection']['edges'][number]['node']

export const useWorkSpacesWithBookings = (variables: GetWorkSpacesWithBookingsQueryVariables) => {
  const { nodes, controls } = usePaginatedQuery(GetWorkSpacesWithBookingsDocument, {
    variables,
    extractConnection: (dataToExtract) =>
      dataToExtract.spaceControl.workSpaceWithBookingsConnection ?? DEFAULT_PAGINATED_CONNECTION,
  })

  return {
    workSpaces: nodes,
    controls,
  }
}
